import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import MentorList from './components/MentorList';
import Chat from './components/Chat';
import Settings from './components/Settings';

function App() {
    const [token, setToken] = useState(localStorage.getItem('token'));

    const setAuthToken = (newToken) => {
        if (newToken) {
            localStorage.setItem('token', newToken);
        } else {
            localStorage.removeItem('token');
        }
        setToken(newToken);
    };

    const logout = () => {
        setAuthToken(null);
    };

    return (
        <Router>
            <div className="container">
                <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h1>Mentor Platform</h1>
                    {token && (
                        <div>
                            <Link to="/" style={{ marginRight: '15px', color: 'white' }}>Mentors</Link>
                            <Link to="/settings" style={{ marginRight: '15px', color: 'white' }}>Settings</Link>
                            <button onClick={logout}>Logout</button>
                        </div>
                    )}
                </nav>

                <Routes>
                    <Route path="/login" element={!token ? <Login setToken={setAuthToken} /> : <Navigate to="/" />} />
                    <Route path="/register" element={!token ? <Register /> : <Navigate to="/" />} />
                    <Route path="/" element={token ? <MentorList token={token} /> : <Navigate to="/login" />} />
                    <Route path="/chat/:mentorId" element={token ? <Chat token={token} /> : <Navigate to="/login" />} />
                    <Route path="/settings" element={token ? <Settings token={token} /> : <Navigate to="/login" />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
